export default function updateClientAction(context, payload, done) {
    context.dispatch('USER_CLIENTS_UPDATED', payload);
    done();
}
